<template>
  <div :class="$style.root">
    <el-menu
      router
      :collapse="isCollapse"
      :default-active="`/${route.path?.split('/')[1]}`"
      :class="$style.el_menu"
    >
      <template v-for="menu in authMenu" :key="menu.path">
        <!-- 一级 -->
        <el-menu-item :index="menu.path" @click="router.push(menu.path)" v-if="!menu.children">
          <el-icon><component :is="menu.icon" /></el-icon>
          <template #title>{{ menu.name }}</template>
        </el-menu-item>

        <!-- 二级 -->
        <el-sub-menu index="system" v-else>
          <template #title>
            <el-icon><component :is="menu.icon" /></el-icon>
            <span>{{ menu.name }}</span>
          </template>
          <template v-for="item in menu.children" :key="item.path">
            <el-menu-item
              :key="item.path"
              :index="item.path"
              v-if="!item.children"
              @click="router.push(item.path)"
              >{{ item.name }}</el-menu-item
            >

            <!-- 三级 -->
            <el-sub-menu v-for="sub in item.children" :index="sub.path" :key="sub.path" v-else>
              <template #title>
                {{ item.name }}
              </template>
              <el-menu-item :index="item.path" :key="sub.path" @click="router.push(sub.path)">{{
                sub.name
              }}</el-menu-item>
            </el-sub-menu>
          </template>
        </el-sub-menu>
      </template>
    </el-menu>

    <div :class="$style.switch">
      <el-tooltip effect="dark" :content="isCollapse ? '展开导航栏' : '折叠导航栏'" placement="top">
        <el-button @click="isCollapse = !isCollapse" circle size="large">
          <template #icon>
            <el-icon size="20px"><Expand v-if="isCollapse" /> <Fold v-else /></el-icon>
          </template>
        </el-button>
      </el-tooltip>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref, computed, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { House, User, Setting, School, Cpu, Postcard } from '@element-plus/icons-vue'
import { getCachedProfile } from '@/utils'

const route = useRoute()
const router = useRouter()
const isCollapse = ref(true)
const profile = getCachedProfile()

const menus = [
  {
    path: '/home',
    name: '首页',
    icon: House,
    auth: ['r_admin', 'r_doctor']
  },
  {
    path: '/patients',
    name: '患者管理',
    icon: User,
    auth: ['r_admin', 'r_doctor']
  },
  {
    path: '/devices',
    name: '设备管理',
    icon: Cpu,
    auth: ['r_admin']
  },
  {
    path: '/hospitals',
    name: '医院管理',
    icon: School,
    auth: ['r_admin']
  },
  {
    path: '/users',
    name: '账户管理',
    icon: Postcard,
    auth: ['r_admin']
  },
  {
    path: '/settings',
    name: '系统管理',
    icon: Setting,
    auth: ['r_admin', 'r_doctor'],
    children: [
      {
        path: '/settings/profile',
        name: '个人信息',
        auth: ['r_admin', 'r_doctor']
      },
      {
        path: '/settings/password',
        name: '修改密码',
        auth: ['r_admin', 'r_doctor']
      },
      {
        path: '/settings/data-management',
        name: '数据管理',
        auth: ['r_admin'],
        children: [
          {
            path: '/settings/data-management/image-archive',
            name: '图片归档',
            auth: ['r_admin']
          }
        ]
      }
    ]
  }
]

watch(route, () => {
  if (route.name === '患者检查报告') {
    isCollapse.value = true
  }
})

const authMenu = computed(() => {
  return menus.filter((v) => {
    v.children = v.children?.filter((c) => c.auth.some((a) => a === profile?.roleCode))
    return v.auth.some((r) => r === profile?.roleCode)
  })
})

const handleResize = () => {
  if (route.name !== '患者检查报告') {
    isCollapse.value = window.innerWidth < 1068
  }
}

onMounted(() => {
  handleResize() // Initialize collapse state based on initial window size
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})
</script>

<style lang="scss" module>
.root {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  justify-content: space-between;
  align-items: center;
  border-right: 1px solid #dcdfe6;

  .el_menu {
    flex: 1;
    height: 100%;
    border-right: none;
  }

  .switch {
    padding: 12px;
    margin-bottom: 20px;
    box-sizing: border-box;
  }
}
</style>
